import React, { useEffect, useState } from "react";
import { FaCalendarAlt } from "react-icons/fa";
import {
  Container,
  Nav,
  Navbar,
  NavbarBrand,
  NavItem,
  NavLink,
} from "reactstrap";
import {
  getCurrentEscolaId,
  getCurrentUser,
  isCurrentUserAdmin,
  setUserToken,
} from "../api/base";
import periodosLetivosService, {
  PeriodosLetivosResponse,
} from "../api/periodosLetivos";

interface LayoutProps {
  children?: React.ReactNode;
  authenticated: boolean;
}

export function Layout(props: LayoutProps) {
  const currentUser = getCurrentUser();
  const currentEscolaId = getCurrentEscolaId();
  const schoolSelectionPending =
    props.authenticated && isCurrentUserAdmin() && !currentEscolaId;
  const [currentPeriod, setCurrentPeriod] =
    useState<PeriodosLetivosResponse | null>(null);

  useEffect(() => {
    if (props.authenticated && !schoolSelectionPending) {
      periodosLetivosService
        .getCurrentPeriod()
        .then((period) => setCurrentPeriod(period))
        .catch(() => setCurrentPeriod(null)); // Silently fail if no current period
    } else {
      setCurrentPeriod(null);
    }
  }, [props.authenticated, schoolSelectionPending]);

  const onLogout = (e: React.MouseEvent) => {
    e.preventDefault();
    setUserToken(null);
  };

  return (
    <div>
      {props.authenticated && (
        <div>
          <Navbar color="light" className="border-bottom">
            <NavbarBrand href="/">AssimAprende</NavbarBrand>
            <Nav>
              {currentPeriod && !schoolSelectionPending && (
                <NavItem>
                  <NavLink
                    disabled
                    className="text-muted d-flex align-items-center"
                  >
                    <FaCalendarAlt className="me-1" />
                    {currentPeriod.nome}
                  </NavLink>
                </NavItem>
              )}
              {currentUser && (
                <NavItem>
                  <NavLink disabled style={{ color: "#6c757d" }}>
                    {currentUser}
                  </NavLink>
                </NavItem>
              )}
              <NavItem>
                <NavLink href="/usuarios/conta">Minha Conta</NavLink>
              </NavItem>
              <NavItem>
                <NavLink href="/login" onClick={(e) => onLogout(e)}>
                  Sair
                </NavLink>
              </NavItem>
            </Nav>
          </Navbar>
          {!schoolSelectionPending && (
            <Navbar color="light" style={{ paddingTop: 0 }}>
              <Nav>
                <NavItem>
                  <NavLink href="/atividades">Atividades</NavLink>
                </NavItem>
                <NavItem>
                  <NavLink href="/turmas">Turmas</NavLink>
                </NavItem>
                <NavItem>
                  <NavLink href="/relatorios">Relatórios</NavLink>
                </NavItem>
                <NavItem>
                  <NavLink href="/escolas">Escolas</NavLink>
                </NavItem>
                <NavItem>
                  <NavLink href="/periodos-letivos">Períodos Letivos</NavLink>
                </NavItem>
                <NavItem>
                  <NavLink href="/usuarios">Usuários</NavLink>
                </NavItem>
              </Nav>
            </Navbar>
          )}
        </div>
      )}
      <Container style={{ marginTop: "2em", marginBottom: "2em" }}>
        {props.children}
      </Container>
    </div>
  );
}
